
import bootbox from 'bootbox/bootbox';

bootbox.setDefaults({
    size: 'lg',
    closeButton: false,
    centerVertical: true,
    animate: true,
});

export default bootbox;
